import CheckmarkGreenSmallIconPath from "@ingka/ssr-icon/paths/checkmark-green-small";

export default CheckmarkGreenSmallIconPath;
